export class RequestAbortError extends Error {
  constructor(options?: ErrorOptions) {
    super('Request aborted', options);
    this.name = 'RequestAbortError';
  }
}
